import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import { FC } from "react";
import { FlexFieldPanelAssignment } from "../../../components/FlexFieldPanelAssignment";

export interface IFlexFieldPanelAssignmentPage {}

export const FlexFieldPanelAssignmentPage: FC<IFlexFieldPanelAssignmentPage> =
  () => {
    return (
      <AuthenticatedLayout
        pageTitle="Flex Field Panel Assignment Setup"
        breadcrumbCurrentPageName=""
        breadcrumbLinks={[]}
        mainContents={
          <FlexFieldPanelAssignment testId="flex-field-panel-assignment-setup" />
        }
      />
    );
  };
